import { PageRouteBaseConfig } from '@/App/AppRoutes/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { selectForgotPassword } from '@/features/user/forgotPassword/selectForgotPassword';

export const ForgotPasswordRouteBase: PageRouteBaseConfig = {
  key: 'forgot-password-page',
  path: '/forgot_password/:locale?',
  screenRef: ScreenRef.FORGOT_PASSWORD,
  actionRef: ActionRef.FORGOT_PASSWORD,
  selector: selectForgotPassword,
};
